import React,{useState, useEffect} from 'react';
import InputMask from "react-input-mask";
import If from './components/If';
import './App.css';

function App() {

    const [showHeader, setShowHeader] = useState(true);

    const [productInfo, setProductInfo] = useState({picture: null, name: null, size: null, price: null});
    const [sellersList, setSellersList] = useState(null);
    const [whatsappToSend, setWhatsappToSend] = useState("");
    const [storeName, setStoreName] = useState("");
    const [sellerID, setSellerID] = useState("");
    const [sellerSents, setSellerSents] = useState("");
    const [invalidURL, setInvalidURL] = useState(false);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [cep, setCep] = useState("");

    const [street, setStreet] = useState("")
    const [town, setTown] = useState("");
    const [uf, setUF] = useState("");

    const originURL = window.location.href; 

    useEffect(() => {
        if (town && street && uf) {
            SelectSeller();
        }
    }, [town, uf, street]);

    useEffect(() => {
        const searchParams = new URLSearchParams(originURL);

        // if(searchParams.has("picture") && searchParams.has("name") && searchParams.has("size") && searchParams.has("price")) {
        //     setProductInfo({picture: searchParams.get("picture"), name: searchParams.get("name"), size: searchParams.get("size"), price: searchParams.get("price")})
        // } else {
        //     setInvalidURL(true);
        // }

        if(searchParams.has("neutral")) {
            setShowHeader(false);
        } 

        fetch('https://api.sheety.co/0a34b7201289c69647d7f8c626404ba2/comprasWhatsApp/vendedores')
        .then(response => response.json())
            .then(data => {
                setSellersList(data.vendedores);
            });
    }, []);

    useEffect(() => {
        if (!cep.includes("_") && cep.length > 8) {
            fetch('https://viacep.com.br/ws/'+ cep +'/json/', {
            headers : { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }})
            .then(response => response.json())
            .then(data => {
                setStreet(data.logradouro);
                setTown(data.localidade);
                setUF(data.uf);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }
    }, [cep]);

    function SelectSeller() {
        //RR => AM Roraima não tem vendedores, Amazonas tem
        // let tempArray = sellersList.filter(seller => Slugify(seller.cidade).includes(Slugify(town)));
        let tempArray = sellersList.filter(seller => Slugify(seller.estado).includes(Slugify(uf)));
        tempArray = tempArray.filter(seller => Slugify(seller.cidade).includes(Slugify(town)));

        if(tempArray.length === 0) {
            tempArray = sellersList.filter(seller => Slugify(seller.estado) ===  Slugify(uf));
        }


        if(tempArray.length > 1) {
            tempArray.sort((a, b) => (parseInt(a.recebidos) < parseInt(b.recebidos)) ? -1 : 1);
        }

        setSellerID(tempArray[0].id);
        setStoreName(tempArray[0].nome)
        setWhatsappToSend(tempArray[0].telefone);
        setSellerSents(tempArray[0].recebidos);
    }

    function Slugify(name) {
        const a = 'àáâãçéêíôóú';
        const b = 'aaaaceeioou';
        const p = new RegExp(a.split('').join('|'), 'g');
    
        return name.toString().toLowerCase().replace(p, c => b.charAt(a.indexOf(c)));
    }

    function SendToWhatsApp() {
        const newRecieveds = {
            vendedore: {
                recebidos: parseInt(sellerSents + 1),
            }
        }        
        

        fetch('https://api.sheety.co/0a34b7201289c69647d7f8c626404ba2/comprasWhatsApp/vendedores/' + sellerID, {
            headers: { "Content-Type": "application/json; charset=utf-8" },
            method: 'PUT',
            body: JSON.stringify(newRecieveds),
            }).then((response) => response.json())
            .then(json => {
            console.log(json.vendedore);
        });

        const formData = {
            lead: {
                nome: name,
                eMail: email,
                telefone: phone,
                cep: cep,
                vendedor: whatsappToSend.toString(),
                loja: storeName,
            }
        }

        fetch('https://api.sheety.co/0a34b7201289c69647d7f8c626404ba2/skinCollection/leads/', {
            headers: { "Content-Type": "application/json; charset=utf-8" },
            method: 'POST',
            body: JSON.stringify(formData),
            }).then(response => {
                console.log(response)
            }).catch(error => {
                console.log(error.response);
        });

        // const fixedPriced = productInfo.price.slice(0, productInfo.price.length - 2) + "," + productInfo.price.slice(productInfo.price.length - 2);

        // const pictureURL = encodeURIComponent(productInfo.picture);
        const lpURL = encodeURIComponent('https://marketing.labellamafia.com.br/skin-collection/');
        // const message = `${pictureURL}%0A${productInfo.name}%0A${productInfo.size}%0AR$%20${fixedPriced}%0A%0ANome:%20${name}%0ATelefone:%20${phone}%0AE-mail:%20${email}%0ACEP:%20${cep}%0ACidade:%20${town}%0AEstado:%20${uf}`;
        // const message = `Oi, eu quero garantir a minha Lingerie Labellamafia Skin Collection.%0A${lpURL}%0A%0ANome:%20${name}%0ATelefone:%20${phone}%0AE-mail:%20${email}%0ACEP:%20${cep}%0ACidade:%20${town}%0AEstado:%20${uf}`;
        let message;
        if (showHeader) {
            message = `Oi, eu quero garantir a minha Lingerie Labellamafia Skin Collection.%0A${lpURL}%0A%0ANome:%20${name}%0ATelefone:%20${phone}%0AE-mail:%20${email}%0ACEP:%20${cep}%0ACidade:%20${town}%0AEstado:%20${uf}`;
        } else {
            message = `Oi, quero garantir meu look exclusivo Labellamafia! Você pode me ajudar?%0A%0ANome:%20${name}%0ATelefone:%20${phone}%0AE-mail:%20${email}%0ACEP:%20${cep}%0ACidade:%20${town}%0AEstado:%20${uf}`;
        }
        const waURL = `https://api.whatsapp.com/send?phone=${whatsappToSend}&text=${message}`;
        window.open(waURL, "_blank");
    }    

    return (
        <div className="App">
            <div className="container">
            {/* <If test={invalidURL}>
                <div className="error_screen">
                    <h2>Algo deu errado!</h2>
                    <p>Por favor, clique novamente no link da página de produto e <span>NÃO EDITE</span> a URL desta página!</p> 
                </div>
            </If> */}
            <If test={!invalidURL}>
                {/* <div className="video_container">
                    <iframe src="https://www.youtube.com/embed/eYJmx30LhD0" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title="tutorial"></iframe>
                </div> */}
                <If test={showHeader}>
                    <div className="cover">
                            <img src="http://marketing.labellamafia.com.br/wp-content/uploads/2020/10/capa-1.png" alt="capa" loading="lazy"/>
                    </div>
                </If>      
                <If test={!showHeader}>
                    <div className="cover_neutral">
                            <img src="http://marketing.labellamafia.com.br/wp-content/uploads/2020/08/home_2020_logo_lbm.png" alt="capa" loading="lazy"/>
                    </div>
                </If>          
                <div className="content">
                    {/* <p className="hint">Saiba como funciona nossa venda por WhatsApp.</p> */}
                    {/* <p className="hint">A coleção de lingerie Skin Collection é exclusiva para nossas lojas físicas.</p> */}
                    <p>Preencha os dados abaixo corretamente, incluindo seu CEP para que possamos direcionar seu atendimento a nossa loja mais próxima de você.</p>
                    <div className="input_group">
                        <input type="text" placeholder="NOME" id="inp_name" value={name} onChange={event => setName(event.currentTarget.value)} />
                        <input type="text" placeholder="E-MAIL" id="inp_email" value={email} onChange={event => setEmail(event.currentTarget.value)}/>
                        <InputMask mask="+55 99 99999-9999" placeholder="TELEFONE" id="inp_phone" value={phone} onChange={event => setPhone(event.currentTarget.value)}/>
                        <InputMask mask="99999-999" placeholder="CEP" id="inp_cep" value={cep} onChange={event => setCep(event.currentTarget.value)}/>
                        <If test={street && town && uf}>
                            <p className="address_info">{street} - {town} - {uf}</p>
                        </If>
                        <If test={!cep.includes("_") && cep.length > 8 && !(street && town && uf)}>
                            <p className="error">Digite um CEP válido (apenas números)</p>
                        </If>                  
                    </div>
                    <button onClick={SendToWhatsApp} disabled={!(name && cep && email.includes("@") && email.includes(".") && phone.length > 8 && !phone.includes("_") && street && town && uf)}>
                        {/* <legend>comprar via whatsapp</legend> */}
                        <legend>Enviar Mensagem</legend>
                        <img src={process.env.PUBLIC_URL + '/whatsapp.png'} alt="logo"/>
                    </button>
                    {/* <p className="hint">Clique no botão acima para comprar seu produto em uma de nossas lojas mais perto de você.</p> */}
                    <If test={showHeader}>
                        <p className="hint">Clique no botão acima para reservar sua lingerie em uma de nossas lojas mais perto de você.</p>
                    </If>
                    <If test={!showHeader}>
                        <p className="hint">Clique no botão acima para reservar sua compra em uma de nossas lojas mais perto de você.</p>
                    </If>                    
                </div>
            </If>   
                
            </div>
        </div>
    );
}

export default App;